import React, { useEffect } from "react";
import { Form, Input, Select, Button, Space } from "antd";

const { Option } = Select;
const { TextArea } = Input;

const TaskForm = ({ initialValues, onSubmit, onCancel }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        config: initialValues.config || "",
      });
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (err) {
      console.error("表单验证失败:", err);
    }
  };

  return (
    <Form form={form} layout="vertical">
      <Form.Item
        label="任务名称"
        name="name"
        rules={[{ required: true, message: "请输入任务名称" }]}
      >
        <Input placeholder="请输入任务名称" />
      </Form.Item>

      <Form.Item
        label="任务类型"
        name="type"
        rules={[{ required: true, message: "请选择任务类型" }]}
      >
        <Select placeholder="请选择任务类型">
          <Option value="report">报告生成</Option>
          <Option value="validation">数据校验</Option>
          <Option value="sync">数据同步</Option>
          <Option value="backup">数据备份</Option>
          <Option value="cleanup">数据清理</Option>
          <Option value="alert_check">告警检查</Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="调度规则"
        name="schedule"
        rules={[{ required: true, message: "请输入调度规则" }]}
        extra="Cron 表达式，例如: 0 0 * * * (每天0点)"
      >
        <Input placeholder="例如: 0 0 * * *" />
      </Form.Item>

      <Form.Item
        label="配置信息"
        name="config"
        extra="JSON 格式的配置信息（可选）"
      >
        <TextArea
          rows={4}
          placeholder='例如: {"report_type": "daily", "format": "excel"}'
        />
      </Form.Item>

      <Form.Item>
        <Space>
          <Button type="primary" onClick={handleSubmit}>
            提交
          </Button>
          <Button onClick={onCancel}>取消</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default TaskForm;
